
import type { PropOptions } from 'vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'BravadoIconButton',
  props: {
    variant: {
      type: String,
      default: 'theme',
    } as PropOptions<'transparent' | 'theme'>,
  },
});
